import { ChangeDetectorRef, Component } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { RecipientsSearchComponent } from '../search/recipients-search/recipients-search.component';
import { RecipientsFilterComponent } from '../filter/recipients-filter/recipients-filter.component';
import { RecipientsTableComponent } from '../table/recipients-table/recipients-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dl-recipients-list',
  standalone: true,
  imports:[OneWebComponentsAngularModule,CommonModule,RecipientsTableComponent,RecipientsSearchComponent,RecipientsFilterComponent,ReactiveFormsModule,FormsModule],
  templateUrl: './recipients-list.component.html',
  styleUrl: './recipients-list.component.scss'
})
export class RecipientsListComponent {

  public isLimit: boolean = false;
  public isWarn: boolean = false;
  public contacts: number = 0;
  public accounts: number = 0;
  
  public constructor(
    private _cdr: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {}

  public contactLimit(islimit: boolean){
    this.isLimit = islimit;
  }
  public contactWarn(iswarn: boolean){
    this.isWarn = iswarn;
    this._cdr.detectChanges();
  }

   public contactData(dataCount: any[]){

    this.contacts = dataCount[0];
    this.accounts = dataCount[1];
    this._cdr.detectChanges();
  }
}

